import { ChangeDetectionStrategy, Component, ElementRef, input, linkedSignal, output, viewChild } from '@angular/core'
import { IconComponent } from '../icons/icons.component'

@Component({
  selector: 'accordion2',
  imports: [IconComponent],
  templateUrl: './accordion2.component.html',
  styleUrls: ['./accordion2.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Accordion2Component {
  isOpen = input<boolean>(false)
  identifier = input.required<string>()

  input = viewChild<ElementRef<HTMLInputElement>>('input')

  hasChange = output<boolean>()
  isChecked = linkedSignal<boolean>(() => this.isOpen())

  toggle() {
    const isChecked = this.input()?.nativeElement.checked ?? false

    this.isChecked.set(isChecked)
    this.hasChange.emit(isChecked)
  }
}
